import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Logger } from '../utils/logger';
import CarouselWrapper from '../consumers/PrescreenConsumer/CarouselWrapper';
import NpsSurvey from '../consumers/PrescreenConsumer/NpsSurvey';
import CustomPrescreen from '../consumers/PrescreenConsumer/CustomPrescreen';
import IframePrescreen from '../consumers/PrescreenConsumer/IframePrescreen';
import { LightBoxFooter } from './LightBoxFooter';
import { PopUpWindow } from './PopUpWindow';
import { Styled } from './LightBox.styles';
const isValidUrl = (url) => {
    try {
        const urlObj = new URL(url);
        return urlObj.protocol === 'https:';
    }
    catch (err) {
        return false;
    }
};
const LightBox = ({ data, onClose, onPrescreenClick, onPrescreenButtonClick, onContentShown, setBrazeCustomAttribute, onURLButtonClick, }) => {
    var _a;
    const [popUpWindowVisible, setPopUpWindowVisible] = useState(true);
    useEffect(() => {
        popUpWindowVisible ? onContentShown() : onClose();
    }, [popUpWindowVisible]);
    const popUpWindowHide = () => setPopUpWindowVisible(false);
    let popUpWindowContent;
    let noPadding = true;
    const popUpWindowActions = !data.isHTML && data.hasButton ? (_jsx(LightBoxFooter, { buttons: data.buttons, buttonColor: data.buttonColor, onClick: onPrescreenButtonClick, onClose: onClose })) : null;
    if (data.isHTML && data.message) {
        noPadding = false;
        const sanitizedMessage = data.message.replace(/(\r\n|\n|\r)/gm, '');
        const jsonString = (_a = sanitizedMessage.match(/<PrescreenJson>(.*)<\/PrescreenJson>/)) === null || _a === void 0 ? void 0 : _a[1];
        if (jsonString === undefined)
            return null;
        try {
            const schema = JSON.parse(jsonString);
            switch (schema.type) {
                case 'carousel':
                    popUpWindowContent = (_jsx(CarouselWrapper, { onURLButtonClick: onURLButtonClick, onClose: onClose, value: schema.value }));
                    break;
                case 'nps':
                    popUpWindowContent = (_jsx(NpsSurvey, { onClose: onClose, value: schema.value, setBrazeCustomAttribute: setBrazeCustomAttribute }));
                    break;
                case 'iframe':
                    // don't allow invalid url
                    if (!isValidUrl(schema.url)) {
                        Logger.log('Braze provider- invalid url');
                        return null;
                    }
                    noPadding = true;
                    popUpWindowContent = (_jsx(IframePrescreen, { url: schema.url, introScreen: schema.introScreen, onClose: onClose, introScreenButtonText: schema.introScreenButtonText }));
                    break;
                case 'custom':
                    popUpWindowContent = (_jsx(CustomPrescreen, { content: schema.value, onClose: onClose, onURLButtonClick: onURLButtonClick }));
            }
        }
        catch (e) {
            Logger.log(e);
            return null;
        }
    }
    else if (data.template === 'full_background') {
        popUpWindowContent = (_jsx(Styled.FullSizeDiv, { backgroundImageURL: data.template ? data.imageUrl : undefined, mobileBackgroundImageURL: data.mobileImageURL, onClick: onPrescreenClick, children: _jsx(Styled.FullBackgroundFooter, { children: popUpWindowActions }) }));
        return (_jsx(PopUpWindow, { isShown: popUpWindowVisible, hide: popUpWindowHide, noPadding: noPadding, actions: null, removeCrossIcon: data.removeCrossIcon, template: data.template, children: popUpWindowContent }));
    }
    else if (data.messageClickAction === 'URI' && data.messageUrl) {
        popUpWindowContent = (_jsx(Styled.PopupWindowImage, { src: data.imageUrl, alt: data.buttonText || data.messageUrl, title: data.buttonText || data.messageUrl, onClick: onPrescreenClick }));
    }
    else {
        popUpWindowContent = (_jsx(Styled.PopupWindowImage, { src: data.imageUrl, alt: data.buttonText || data.messageUrl, title: data.buttonText || data.messageUrl, onClick: onPrescreenClick }));
    }
    return (_jsx(PopUpWindow, { isShown: popUpWindowVisible, hide: popUpWindowHide, noPadding: noPadding, actions: popUpWindowActions, removeCrossIcon: data.removeCrossIcon, template: data.template, children: popUpWindowContent }));
};
export { LightBox };
//# sourceMappingURL=LightBox.js.map